import { Component, OnInit } from "@angular/core";

import { BaseSelectionList } from "../base/base-selection-list.component";
import { OrganizationsService } from "./../../../../core/api/services/organizations.service";

@Component({
    selector: "artistic-culture-selection-list",
    templateUrl: "./artistic-culture-selection-list.component.html",
    standalone: false
})
export class ArtisticCultureSelectionListComponent
  extends BaseSelectionList
  implements OnInit
{
  artisticCulture: any[] = [
    { id: 1, name: "هنرمندان" },
    { id: 2, name: "نویسندگان" },
    { id: 3, name: "خبرنگاران" },
    { id: 4, name: "بازیگران" },
    { id: 5, name: "ناشرین" },
  ];
  constructor(protected currentService: OrganizationsService) {
    super();
  }

  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  initConfig() {
    this.optionValue = "id";
    this.optionTitle = "name";
    this.sortKey = "id";

    if (!this.input_label) this.input_label = "common.artisticCulture";
  }

  getItems() {
    this.items = this.artisticCulture;
  }
}
